import { Drawer, Select } from "@caprikorn/dynamo-ui";
import { type FC, type FormEvent, useId, useState } from "react";

import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./RoleDrawer.module.css";
import type { AccessRole, RoleDrawerProps } from "./RoleDrawer.types";

export const RoleDrawer: FC<RoleDrawerProps> = ({
  isAdmin,
  isSubmitting,
  onHide,
  onSubmit,
}) => {
  const { t } = useCustomTranslation("main");
  const formId = useId();
  const [role, setRole] = useState<AccessRole>(
    isAdmin ? "ADMIN" : "RESTRICTED",
  );
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    return onSubmit(role);
  };

  return (
    <Drawer onClose={onHide}>
      <Drawer.Header title={t("userDetails.role.drawer")} />
      <Drawer.Body className={classes.body}>
        <form id={formId} onSubmit={handleSubmit}>
          <Select
            label={t("userDetails.role.labels.userRole")}
            onChange={(value) => setRole(value as AccessRole)}
            size="lg"
            value={role}
          >
            <Select.Trigger
              className={classes.input}
              data-testid="PageSizeSelector"
            />
            <Select.Dropdown data-testid="DropDown-List">
              <Select.Options>
                <Select.Option
                  label={t("userDetails.role.labels.restricted")}
                  value="RESTRICTED"
                />
                <Select.Option
                  label={t("userDetails.role.labels.admin")}
                  value="ADMIN"
                />
              </Select.Options>
            </Select.Dropdown>
          </Select>
        </form>
        {role === "RESTRICTED"
          ? t("userDetails.role.restricted.intro")
          : t("userDetails.role.admin.intro")}
        <ul className={classes.list}>
          {role === "RESTRICTED" ? (
            <li>{t("userDetails.role.restricted.restrictedPerimeter")}</li>
          ) : (
            <>
              <li>{t("userDetails.role.admin.info.perimeterAccess")}</li>
              <li>{t("userDetails.role.admin.info.addUser")}</li>
              <li>{t("userDetails.role.admin.info.sharePerimeter")}</li>
              <li>{t("userDetails.role.admin.info.deleteAccess")}</li>
            </>
          )}
        </ul>
      </Drawer.Body>
      <Drawer.Footer>
        <Drawer.Footer.ConfirmButton
          disabled={isSubmitting}
          form={formId}
          type="submit"
        />
        <Drawer.Footer.CancelButton />
      </Drawer.Footer>
    </Drawer>
  );
};
